import { Subject } from 'rxjs';
if (!window.globalEventBus) {
  window.globalEventBus = new Subject();
}
export const eventBus = window.globalEventBus;